import { useEffect, useRef } from "react";
import { useWidgetStore } from "../../store/widget-store";
import { MessageBubble } from "./MessageBubble";

export function MessageList() {
  const messages = useWidgetStore((state) => state.messages);
  const status = useWidgetStore((state) => state.messagesStatus);
  const error = useWidgetStore((state) => state.messagesError);
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages.length]);

  if (status === "loading") {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-gray-400">
        Loading conversation…
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="flex flex-1 items-center justify-center px-4 text-center text-sm text-red-500">
        {error ?? "Couldn't load the conversation."}
      </div>
    );
  }

  if (messages.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center px-4 text-center text-sm text-gray-400">
        Send a message to start the conversation.
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col gap-2 overflow-y-auto px-3 py-3">
      {messages.map((message) => (
        <MessageBubble key={message.id} message={message} />
      ))}
      <div ref={bottomRef} />
    </div>
  );
}
